import { render, staticRenderFns } from "./IpFirewallModal.vue?vue&type=template&id=dcd963b2&scoped=true"
import script from "./IpFirewallModal.vue?vue&type=script&lang=js"
export * from "./IpFirewallModal.vue?vue&type=script&lang=js"
import style0 from "./IpFirewallModal.vue?vue&type=style&index=0&id=dcd963b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd963b2",
  null
  
)

export default component.exports